(function () {
  'use strict';

  
  const CONFIG = {
    
    swiperSelector: '.swiper, [class*="swiper-container"]',

    
    initAttr: 'data-a11y-carousel-init',

    
    minSlides: 2,

    
    maxWaitMs: 8000,

    
    pollInterval: 100,

    
    focusableSelector: [
      'a[href]',
      'area[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'iframe',
      'object',
      'embed',
      'audio[controls]',
      'video[controls]',
      'details > summary',
      '[contenteditable]:not([contenteditable="false"])',
      '[tabindex]',           
    ].join(', '),
  };

  
  function srOnly(text, id) {
    const el = document.createElement('p');
    el.className = 'swiper-a11y-sr-only';
    el.textContent = text;
    if (id) el.id = id;
    return el;
  }

  
  function chevronSVG(direction) {
    const points = direction === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
    return `<svg aria-hidden="true" focusable="false" width="16" height="16"
      viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
      <polyline points="${points}"/>
    </svg>`;
  }

  
  function inferCarouselLabel(container) {
    
    const own = container.getAttribute('aria-label');
    if (own && !own.toLowerCase().includes('carousel')) return own + ' carousel';
    if (own) return own;

    
    let node = container.previousElementSibling;
    for (let i = 0; i < 5 && node; i++, node = node.previousElementSibling) {
      if (/^H[1-6]$/i.test(node.tagName)) return node.textContent.trim() + ' carousel';
    }

    
    const landmark = container.closest('section, article, [aria-label], [aria-labelledby], main, aside');
    if (landmark) {
      const landmarkLabel = landmark.getAttribute('aria-label');
      if (landmarkLabel) return landmarkLabel + ' carousel';
      const h = landmark.querySelector('h1,h2,h3,h4,h5,h6');
      if (h) return h.textContent.trim() + ' carousel';
    }

    
    const hint = container.dataset.carouselLabel || container.dataset.sectionId;
    if (hint) return hint.replace(/-/g, ' ') + ' carousel';

    return 'Product carousel';
  }

  
  function getFocusable(container) {
    return Array.from(container.querySelectorAll(CONFIG.focusableSelector)).filter(el => {
      
      
      const style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  
  function hasNativeNavigation(swiper) {
    if (!swiper.params || !swiper.params.navigation) return false;
    if (swiper.params.navigation === false) return false;
    return !!(swiper.navigation && (swiper.navigation.nextEl || swiper.navigation.prevEl));
  }

  function hasNativePagination(swiper) {
    if (!swiper.params || !swiper.params.pagination) return false;
    if (swiper.params.pagination === false) return false;
    return !!(swiper.pagination && swiper.pagination.el);
  }

  
  function getActiveSlidesPerView(swiper) {
    
    const activeParams = swiper.currentBreakpointParams || swiper.params;
    const spv = activeParams && activeParams.slidesPerView;

    if (!spv || spv === 'auto') {
      
      if (swiper.visibleSlides && swiper.visibleSlides.length) {
        return swiper.visibleSlides.length;
      }
      return 1;
    }

    return Math.ceil(Number(spv)) || 1;
  }

  
  function isSlideVisible(swiper, slide, activeIndex, visibleCount) {
    const isLoop = !!(swiper.params && swiper.params.loop);

    if (isLoop) {
      
      
      if (swiper.visibleSlides && swiper.visibleSlides.length) {
        return Array.from(swiper.visibleSlides).some(vs => vs === slide);
      }
      
      return (
        slide.classList.contains('swiper-slide-active') ||
        slide.classList.contains('swiper-slide-visible')
      );
    }

    
    const realIndex = parseInt(slide.dataset.swiperSlideIndex, 10);
    const idx = isNaN(realIndex) ? Array.from(slide.parentNode.children).indexOf(slide) : realIndex;
    return idx >= activeIndex && idx < activeIndex + visibleCount;
  }

  
  
  function applySlideVisibility(ctx) {
    const { swiper, swiperContainer } = ctx;
    if (!swiper || swiper.destroyed) return;

    
    const allSlides = Array.from(
      swiperContainer.querySelectorAll('.swiper-slide')
    );

    
    const realSlides = allSlides.filter(s => !s.classList.contains('swiper-slide-duplicate'));
    const duplicateSlides = allSlides.filter(s => s.classList.contains('swiper-slide-duplicate'));

    const activeIndex = (swiper.realIndex !== undefined && swiper.realIndex !== null)
      ? swiper.realIndex
      : swiper.activeIndex;

    const visibleCount = getActiveSlidesPerView(swiper);
    const total = realSlides.length;

    
    realSlides.forEach((slide, i) => {
      
      if (!slide.dataset.swiperSlideIndex) {
        slide.dataset.swiperSlideIndex = String(i);
      }

      const visible = isSlideVisible(swiper, slide, activeIndex, visibleCount);
      setSlideAccessibility(slide, visible);

      
      slide.setAttribute('aria-label', `Slide ${i + 1} of ${total}`);
    });

    
    duplicateSlides.forEach(slide => {
      setSlideAccessibility(slide, false);
    });

    
    syncInjectedControls(ctx, activeIndex, total, visibleCount);

    
    enhanceNativeNavigation(ctx);
    enhanceNativePagination(ctx, activeIndex);
    if (active) {
  dot.setAttribute('tabindex', '0');
} else {
  dot.setAttribute('tabindex', '-1');
}
  }

  
  function setSlideAccessibility(slide, isVisible) {
    if (isVisible) {
      
      slide.removeAttribute('aria-hidden');

      getFocusable(slide).forEach(el => {
        
        const stored = el.dataset.a11yTabindex;
        if (stored !== undefined) {
          if (stored === '__none__') {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', stored);
          }
          delete el.dataset.a11yTabindex;
        }
        
      });

    } else {
      
      slide.setAttribute('aria-hidden', 'true');

      getFocusable(slide).forEach(el => {
        
        if (el.dataset.a11yTabindex === undefined) {
          const current = el.getAttribute('tabindex');
          
          el.dataset.a11yTabindex = current !== null ? current : '__none__';
        }
        el.setAttribute('tabindex', '-1');
      });
    }
  }

  
  function syncInjectedControls(ctx, activeIndex, total, visibleCount) {
    const { swiper, dots, prevBtn, nextBtn } = ctx;
    const isLoop = !!(swiper.params && swiper.params.loop);

    
    if (prevBtn && nextBtn) {
      if (!isLoop) {
        prevBtn.disabled = activeIndex === 0;
        nextBtn.disabled = activeIndex >= total - visibleCount;
      } else {
        prevBtn.disabled = false;
        nextBtn.disabled = false;
      }
      prevBtn.setAttribute('aria-disabled', prevBtn.disabled ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', nextBtn.disabled ? 'true' : 'false');
    }

    
    if (dots && dots.length) {
    dots.forEach((dot, i) => {
      const active = i === activeIndex;
      const li = dot.closest('li');

      dot.setAttribute('aria-selected', active ? 'true' : 'false');

      dot.classList.toggle('swiper-a11y-dot--active', active);

      if (li) {
        li.classList.toggle('swiper-a11y-dot-item--active', active);
      }

      if (active) {
        dot.setAttribute('tabindex', '0');
      } else {
        dot.setAttribute('tabindex', '-1');
      }
    });
  }
  }

  
  function enhanceNativeNavigation(ctx) {
    const { swiper } = ctx;
    if (!swiper.navigation) return;

    [
      { el: swiper.navigation.prevEl, label: 'Previous slide' },
      { el: swiper.navigation.nextEl, label: 'Next slide'     },
    ].forEach(({ el, label }) => {
      if (!el) return;
      const elements = el instanceof NodeList || Array.isArray(el) ? Array.from(el) : [el];
      elements.forEach(btn => {
        if (!btn || btn.dataset.a11yNavEnhanced) return;
        btn.dataset.a11yNavEnhanced = 'true';

        if (btn.tagName !== 'BUTTON') {
          if (!btn.hasAttribute('tabindex')) btn.setAttribute('tabindex', '0');
          if (!btn.getAttribute('role'))     btn.setAttribute('role', 'button');
          btn.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }
          });
        }
        if (!btn.getAttribute('aria-label') && !btn.getAttribute('aria-labelledby')) {
          btn.setAttribute('aria-label', label);
        }
      });
    });
  }

  
  function enhanceNativePagination(ctx, activeIndex) {
    const { swiper } = ctx;
    if (!swiper.pagination || !swiper.pagination.el) return;

    const containers = swiper.pagination.el instanceof NodeList
      ? Array.from(swiper.pagination.el)
      : [swiper.pagination.el];

    containers.forEach(container => {
      if (!container) return;
      if (!container.getAttribute('role'))       container.setAttribute('role', 'tablist');
      if (!container.getAttribute('aria-label')) container.setAttribute('aria-label', 'Slide navigation');

      const bullets = Array.from(container.querySelectorAll('.swiper-pagination-bullet'));
      bullets.forEach((bullet, i) => {
        
        if (!bullet.dataset.a11yBulletEnhanced) {
          bullet.dataset.a11yBulletEnhanced = 'true';
          bullet.setAttribute('role', 'tab');
          if (bullet.tagName !== 'BUTTON') {
            if (!bullet.hasAttribute('tabindex')) bullet.setAttribute('tabindex', '0');
            bullet.addEventListener('keydown', e => {
              if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); bullet.click(); }
            });
          }
        }
        
        bullet.setAttribute('aria-label', `Go to slide ${i + 1} of ${bullets.length}`);
        bullet.setAttribute('aria-selected', String(i === activeIndex));
      });
    });
  }

  
  function buildControls(ctx) {
    const { region, swiper } = ctx;
    if (hasNativeNavigation(swiper)) { enhanceNativeNavigation(ctx); return; }

    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-a11y-controls';
    wrapper.setAttribute('aria-label', 'Carousel navigation');

    const makeBtn = (dir, label) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `swiper-a11y-btn swiper-a11y-btn--${dir}`;
      btn.setAttribute('aria-label', label);
      btn.innerHTML = chevronSVG(dir);
      return btn;
    };

    const prevBtn = makeBtn('prev', 'Previous slide');
    const nextBtn = makeBtn('next', 'Next slide');

    prevBtn.addEventListener('click', () => { if (!prevBtn.disabled) swiper.slidePrev(); });
    nextBtn.addEventListener('click', () => { if (!nextBtn.disabled) swiper.slideNext(); });

    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);
    region.appendChild(wrapper);

    ctx.prevBtn = prevBtn;
    ctx.nextBtn = nextBtn;
  }

  
  function buildDots(ctx) {
  const { region, slides, swiper } = ctx;

  if (hasNativePagination(swiper)) {
    enhanceNativePagination(ctx, swiper.activeIndex || 0);
    return;
  }

  if (slides.length > 12) return;

  const wrapper = document.createElement('ul');
  wrapper.className = 'swiper-a11y-dots';
  wrapper.setAttribute('role', 'tablist');
  wrapper.setAttribute('aria-label', 'Slide navigation');

  const dots = slides.map((_, i) => {

    const li = document.createElement('li');
    li.className = 'swiper-a11y-dot-item';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('role', 'tab');
    btn.setAttribute('aria-label', `Go to slide ${i + 1} of ${slides.length}`);
    btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');

    btn.className = 'swiper-a11y-dot' + (i === 0 ? ' swiper-a11y-dot--active' : '');

    btn.addEventListener('click', () => swiper.slideTo(i));

    li.appendChild(btn);
    wrapper.appendChild(li);

    return btn;
  });

  region.appendChild(wrapper);
  ctx.dots = dots;
}

  
  function bindKeyboard(ctx) {
    const { region, swiper, swiperContainer } = ctx;

    region.addEventListener('keydown', e => {
      if (swiper.destroyed) return;
      
      if (!swiperContainer.contains(document.activeElement)) return;

      switch (e.key) {
        case 'ArrowLeft':
        case 'ArrowUp':    e.preventDefault(); swiper.slidePrev(); break;
        case 'ArrowRight':
        case 'ArrowDown':  e.preventDefault(); swiper.slideNext(); break;
        case 'Home':       e.preventDefault(); swiper.slideTo(0); break;
        case 'End':        e.preventDefault(); swiper.slideTo(ctx.slides.length - 1); break;
      }
    });
  }

  
  function annotateSlides(slides) {
    slides.forEach((slide, i) => {
      if (!slide.getAttribute('role')) slide.setAttribute('role', 'group');
      slide.setAttribute('aria-roledescription', 'slide');
      slide.setAttribute('aria-label', `Slide ${i + 1} of ${slides.length}`);
    });
  }

  
  function buildSRDescription(swiper) {
    const nav = hasNativeNavigation(swiper);
    const pag = hasNativePagination(swiper);

    const parts = [];
    if (nav || (!nav && !pag)) parts.push('Previous and Next buttons');
    if (pag || (!nav && !pag)) parts.push('the dot buttons');

    return `Carousel. Use ${parts.join(' or ')} to navigate between slides. ` +
           `Arrow keys also work when a slide is focused.`;
  }

  
  function rebuildAfterUpdate(ctx) {
    const { region, swiperContainer, swiper } = ctx;

    
    if (!hasNativePagination(swiper)) {
      const old = region.querySelector('.swiper-a11y-dots');
      if (old) old.remove();
      ctx.dots = null;
    }

    
    ctx.slides = Array.from(
      swiperContainer.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
    );

    if (ctx.slides.length < CONFIG.minSlides) return;

    annotateSlides(ctx.slides);
    buildDots(ctx);
    applySlideVisibility(ctx);
  }

  
  function enhanceSwiper(swiperContainer) {
    if (swiperContainer.getAttribute(CONFIG.initAttr)) return;
    swiperContainer.setAttribute(CONFIG.initAttr, 'pending');

    let waited = 0;

    const poll = setInterval(() => {
      waited += CONFIG.pollInterval;
      const swiper = swiperContainer.swiper;

      if (!swiper || !swiper.slides) {
        if (waited >= CONFIG.maxWaitMs) {
          clearInterval(poll);
          swiperContainer.setAttribute(CONFIG.initAttr, 'timeout');
        }
        return;
      }

      clearInterval(poll);

      
      const slides = Array.from(
        swiperContainer.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
      );

      if (slides.length < CONFIG.minSlides) {
        swiperContainer.setAttribute(CONFIG.initAttr, 'skipped');
        return;
      }

      swiperContainer.setAttribute(CONFIG.initAttr, 'true');

      
      const label  = inferCarouselLabel(swiperContainer);
      const region = document.createElement('section');
      region.className = 'swiper-a11y-region';
      region.setAttribute('aria-label', label);
      region.setAttribute('aria-roledescription', 'carousel');
      swiperContainer.parentNode.insertBefore(region, swiperContainer);
      region.appendChild(swiperContainer);

      
      const descId = 'swiper-a11y-desc-' + Math.random().toString(36).slice(2, 8);
      region.insertBefore(srOnly(buildSRDescription(swiper), descId), swiperContainer);
      swiperContainer.setAttribute('aria-describedby', descId);

      
      annotateSlides(slides);

      
      const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
      if (swiperWrapper) swiperWrapper.setAttribute('aria-live', 'polite');

      
      const ctx = { swiperContainer, swiper, slides, region, dots: null, prevBtn: null, nextBtn: null };

      
      buildControls(ctx);
      buildDots(ctx);
      bindKeyboard(ctx);

      
      
      applySlideVisibility(ctx);

      
      
      
      
      
      
      
      
      
      
      

      swiper.on('slideChange',      () => applySlideVisibility(ctx));
      swiper.on('transitionEnd',    () => applySlideVisibility(ctx));
      swiper.on('slidesUpdated',    () => rebuildAfterUpdate(ctx));
      swiper.on('breakpoint',       () => applySlideVisibility(ctx));
      swiper.on('resize',           () => applySlideVisibility(ctx));
      swiper.on('paginationRender', () => enhanceNativePagination(ctx, swiper.activeIndex));
      swiper.on('paginationUpdate', () => enhanceNativePagination(ctx, swiper.activeIndex));

      
      

    }, CONFIG.pollInterval);
  }

  
  function observeDOM() {
    
    document.querySelectorAll(CONFIG.swiperSelector).forEach(enhanceSwiper);

    
    const observer = new MutationObserver(mutations => {
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(CONFIG.swiperSelector)) enhanceSwiper(node);
          if (node.querySelectorAll) {
            node.querySelectorAll(CONFIG.swiperSelector).forEach(enhanceSwiper);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDOM);
  } else {
    observeDOM();
  }

})();